/**
 * Canonical URL segment for a news section. One source of truth for the
 * `[category]` part of article URLs — canonicals, hreflang, sitemaps and the
 * in-page redirect must all build it the same way, otherwise Google sees the
 * same article on several URLs and refuses to index any of them.
 */
export function newsSectionPathSlug(slug: string | null | undefined): string {
  return slug?.toLowerCase() || 'other';
}
